var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1382 15.4788L6.13986 19.0071C6.13931 19.2567 6.18808 19.5039 6.28335 19.7346C6.37863 19.9652 6.51854 20.1748 6.69505 20.3512C7.05468 20.7108 7.53363 20.908 8.04076 20.908L11.8392 20.908C12.0888 20.9086 12.336 20.8598 12.5667 20.7645C12.7973 20.6693 13.0069 20.5294 13.1833 20.3528C13.5429 19.9932 13.7402 19.5143 13.7402 19.0071L13.7402 16.2295C14.7818 15.8381 15.8856 15.6382 16.9984 15.6395C18.1124 15.6368 19.2178 15.835 20.2616 16.2246L20.2616 19.0022C20.261 19.2517 20.3098 19.4989 20.405 19.7296C20.5003 19.9602 20.6402 20.1698 20.8167 20.3462C21.1764 20.7058 21.6553 20.9031 22.1625 20.9031L25.9609 20.9064C26.2109 20.9068 26.4585 20.8579 26.6894 20.7623C26.9204 20.6668 27.1301 20.5265 27.3067 20.3495C27.6663 19.9899 27.8635 19.5109 27.8635 19.0038L27.8635 15.4804C27.8652 14.67 27.537 13.8812 26.9636 13.3077C26.8426 13.1868 26.7167 13.0807 26.5824 12.9862C23.9805 11.1201 20.5764 10.0926 17.0017 10.091C13.4302 10.0893 10.0295 11.1168 7.41596 12.9846C6.61881 13.5563 6.14151 14.4877 6.1382 15.4788V15.4788Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHang);
export default __webpack_public_path__ + "static/media/hang.87bb0223713d8417567199cb5c13ca32.svg";
export { ForwardRef as ReactComponent };